import { TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';

interface MobileGeoLocationFieldProps {
  title: string;
  value: any;
  onChange: (value: any) => void;
}

export const MobileGeoLocationField: React.FC<MobileGeoLocationFieldProps> = ({
  title,
  value,
  onChange,
}) => {
  const [loading, setLoading] = useState(false);

  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      onChange('Geolocation not supported');
      return;
    }

    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        onChange(`${latitude},${longitude}`);
        setLoading(false);
      },
      (err) => {
        console.error(
          'Geolocation error:',
          err instanceof GeolocationPositionError ? err.message : 'Unknown error'
        );
        onChange('Location unavailable');
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (!value) {
      handleGetLocation();
    }
  }, []);

  return (
    <TextField
      fullWidth
      size="small"
      label={title || 'Geo-Location'}
      value={value || (loading ? 'Getting location...' : '')}
      slotProps={{ input: { readOnly: true } }}
    />
  );
};
